import { Inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoadingService } from './loading.service';
import { HttpErrorResponse } from '@angular/common/http';
import { RollbarService } from '../../core/services/rollbar';
import Rollbar from 'rollbar';

export class ErrorHandlerSettings {
  public showSnackBar: boolean;
  public logToRollbar: boolean;
  public logToConsole: boolean;
  public rethrowException: boolean;
  public errorConvetor: (error: any, errorMessage: string) => any;
  public httpErrorConvertor: (error: any, errorMessage: string) => any;
  public returnMessage: boolean;

  /*
    Show Snack Bar: True
    Log to Rollbar: True
    Log to Console: True
    Rethrow: True
  */
  public static Default() : ErrorHandlerSettings {
    return <ErrorHandlerSettings> {
      showSnackBar: true,
      logToRollbar: true,
      logToConsole: true,
      rethrowException: true
    };
  }
}

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(
    private snackBar: MatSnackBar,
    private loader: LoadingService,
    @Inject(RollbarService) private rollbar: Rollbar
  ) { }

  private errorHandlerSettings : ErrorHandlerSettings = ErrorHandlerSettings.Default();

  public configure(errorHandlerSettings: ErrorHandlerSettings) {
    this.errorHandlerSettings = errorHandlerSettings;
  };

  public handleError = (error) => {
    if(this.errorHandlerSettings.logToConsole)
      console.log(error);
    
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else if (error.status == 400) {
      errorMessage = `${error.status}: ${error.statusText} - ${error.error}`;
    } else {
      errorMessage = `${error.status}: ${error.statusText}`;
    }

    if(this.errorHandlerSettings.logToRollbar)
      this.rollbar.error(errorMessage, error);

    if(this.errorHandlerSettings.showSnackBar)
      this.snackBar.open(errorMessage, 'Failed', { duration: 3000, panelClass: 'style-error' });

    if(this.errorHandlerSettings.rethrowException)
      throw error;

    if (this.errorHandlerSettings.errorConvetor)
      return this.errorHandlerSettings.errorConvetor(error, errorMessage);

    if (this.errorHandlerSettings.returnMessage)
      return errorMessage;

    return error;
  }

  public handleHttpError = (error) => {
    if(this.errorHandlerSettings.logToConsole)
      console.log(error);

    let errorMessage = '';
    if (error instanceof HttpErrorResponse && error.status != 500 && error.error != null) {
      errorMessage = error.error;
    } else {
      errorMessage = `${error.status}: ${error.statusText}`;
    }

    if(this.errorHandlerSettings.logToRollbar)
      this.rollbar.error(errorMessage, error);

    if(this.errorHandlerSettings.showSnackBar)
      this.snackBar.open(errorMessage, 'Failed', { duration: 3000, panelClass: 'style-error' });

    if(this.errorHandlerSettings.rethrowException)
      throw error;

    if (this.errorHandlerSettings.httpErrorConvertor)
      return this.errorHandlerSettings.httpErrorConvertor(error, errorMessage);

    if (this.errorHandlerSettings.returnMessage)
      return errorMessage;

    return error;
  }
}
